import './story-page.scss';

import StoryPage from './StoryPage';

export default StoryPage;
